export const getErrorMessage = (error, fallback = "Something went wrong.") => {
  if (typeof error === "string") {
    const trimmed = error.trim();
    return trimmed || fallback;
  }

  const candidate =
    error?.data?.detail ||
    error?.data?.message ||
    (typeof error?.error === "string" ? error.error : null) ||
    error?.message;

  if (typeof candidate === "string") {
    const trimmed = candidate.trim();
    return trimmed || fallback;
  }

  return fallback;
};

